import 'jquery'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Request from './request'
import swal from 'sweetalert2'
import EasySlider from 'vue-easy-slider'


Vue.config.productionTip = false

import '@/assets/css/vendor.bundle.css'
import '@/assets/css/custom-style.css'
import '@/assets/css/style-bitcoin62ea.css'
import '@/assets/css/style.css'

//JavaScript
import '@/assets/js/jquery.bundle.js'
import '@/assets/js/script.js'
import '@/assets/js/custom-script.js'


Vue.use(EasySlider)
Vue.prototype.$socket = Request
Vue.prototype.$swal = swal

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')